import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Button } from 'ui-components/components/button';
import { FlexRow, FlexColumn } from 'ui-components/components/flex';

import { messages } from './messages';
import { ServiceComparison } from './service-comparison';
import style from './style.module.css';
import { RATE_SHOPPER_AUDIT_OPEN, RATE_SHOPPER_AUDIT_LINK_CLICK } from '../../../../constants/analytics-events';
import { Segment } from '../../../../services/analytics-services/segment';
import Global from '../../../../store/global-selectors';

// @ts-expect-error less import

/**
 * @param {object} props
 * @param {() => void} props.closeModal
 * @param {object} props.rateShopperAudit
 * @returns {JSX.Element}
 */
export const RateShopperAudit = ({ closeModal, rateShopperAudit }) => {
  const { services, serviceCollectionGuid } = rateShopperAudit;
  const [isExpanded, setIsExpanded] = useState(false);
  const expandIcon = isExpanded ? faChevronUp : faChevronDown;
  const rateShopper = useSelector((state) =>
    Global.selectSellerServiceCollectionByGuid(state, {
      serviceCollectionGuid,
    }),
  );

  const onExpandContractAudit = useCallback(() => {
    if (!isExpanded) {
      Segment.trackEvent(RATE_SHOPPER_AUDIT_OPEN, {
        type: RATE_SHOPPER_AUDIT_OPEN,
      });
    }
    setIsExpanded(!isExpanded);
  }, [isExpanded]);

  const onNavigateAway = useCallback(() => {
    Segment.trackEvent(RATE_SHOPPER_AUDIT_LINK_CLICK, {
      type: RATE_SHOPPER_AUDIT_LINK_CLICK,
    });
    closeModal();
  }, [closeModal]);

  return (
    <div className={style['rate-shopper-audit']}>
      <FlexRow className={style['audit-header']} onClick={onExpandContractAudit}>
        <FlexRow className={style['rate-shopper-link']}>
          <span className={style['rate-shopper-label']}>
            <FormattedMessage {...messages.rateShopperLabelText} />
          </span>
          <Link onClick={onNavigateAway} to='/settings/rateshopper'>
            {rateShopper.name}
          </Link>
        </FlexRow>
        <FlexColumn>
          <Button theme='unstyled'>
            <FontAwesomeIcon className={style['expand-icon']} icon={expandIcon} />
          </Button>
        </FlexColumn>
      </FlexRow>
      {isExpanded ? <ServiceComparison services={services} /> : null}
    </div>
  );
};
